/** The name the app greets the signed-in user by: the profile's first name,
 *  else the account name before the @, capitalised. Empty when nothing is
 *  known. `profile` is the api/user/profile/ payload (or any object with
 *  `first_name` / `username`); the stored username is the last resort. */
export function displayName(profile) {
  const first = (profile?.first_name || "").trim();
  if (first) return first;
  const username = (profile?.username || localStorage.getItem("username") || "").trim();
  const local = username.split("@")[0];
  return local ? local.charAt(0).toUpperCase() + local.slice(1) : "";
}
